// extracted by mini-css-extract-plugin
export default {"Back":"BackButton_Back__I7BLu","Arrow":"BackButton_Arrow__lRS+8"};